/**
 * Returns given value repeatedly for the provided number of times.
 * The value is repeated indefinitely if no count is provided.
 *
 * @param value value to be repeated
 * @param iterationCount how many times the value should be repeated
 */
export default function *<T>(value: T, iterationCount = Infinity): Generator<T> {
    if (iterationCount === Infinity) {
        while (true) {
            yield value;
        }
    } else {
        for (let i = 0; i < iterationCount; i++) {
            yield value;
        }
    }
}
